import React from "react";
import Draggable from "react-draggable";

import { DraggableSquareContainer } from "./styles";
import { DraggableLogoContainer } from "../Logo/styles";

import { DraggableLabels } from "../Labels";

import { getColor } from "../shapes-utils";

export default function DraggableSquare({
  positions,
  setPositions,
  size = 320,
  squareSizes,
  selectedImage,
  variantColor,
  texts,
  logoSrc,
  x_axis = 50,
}) {
  const handleDrag = (index, e, data) => {
    const newPositions = [...positions];
    newPositions[index] = { x: data.x, y: data.y };
    setPositions(newPositions);
  };
  return (
    <DraggableSquareContainer
      className="shape-container"
      size={size}
      background={getColor(variantColor).primary}
    >
      <Draggable
        key={0}
        // bounds={{
        //   left: -squareSizes.imageSize.width / 2,
        //   top: -squareSizes.imageSize.height / 2,
        //   right: size - squareSizes.imageSize.width / 2,
        //   bottom: size - squareSizes.imageSize.height / 2,
        // }}
        position={positions[0]}
        onDrag={(e, data) => handleDrag(0, e, data)}
      >
        <div
          style={{
            width: squareSizes.imageSize.width + "px",
            height: squareSizes.imageSize.height + "px",
            cursor: "move",
            position: "absolute",
          }}
        >
          <img
            src={selectedImage}
            alt="drag square imag"
            style={{
              width: "100%",
              height: "100%",
              pointerEvents: "none",
              userSelect: "none",
              objectFit: "cover",
              objectPosition: `${x_axis}% 50%`,
            }}
          />
        </div>
      </Draggable>

      <Draggable
        key={1}
        bounds="parent"
        position={positions[1]}
        onDrag={(e, data) => handleDrag(1, e, data)}
      >
        <DraggableLogoContainer size={squareSizes.logoSize}>
          <img
            src={logoSrc}
            alt="drag verticalRectangle imag"
            style={{
              // width: "100%",
              // height: "100%",
              pointerEvents: "none",
              userSelect: "none",
              objectFit: "cover",
            }}
          />
        </DraggableLogoContainer>
      </Draggable>

      <Draggable
        key={11}
        bounds="parent"
        position={positions[2]}
        onDrag={(e, data) => handleDrag(2, e, data)}
      >
        <div
          style={{
            width: squareSizes.labelsSize.width + "px",
            cursor: "move",
            position: "absolute",
          }}
        >
          <DraggableLabels
            style={{
              pointerEvents: "none",
            }}
            callBackground={getColor(variantColor).secondary}
            callText={texts.callText}
            callTextColor={getColor(variantColor).callTextColor}
            primaryText={texts.primaryText}
            secondaryText={texts.secondaryText}
            size={squareSizes.labelsSize}
            textColor={getColor(variantColor).textColor}
          />
        </div>
      </Draggable>
    </DraggableSquareContainer>
  );
}
